import { useTranslation } from 'react-i18next'
import { RequireAccess } from '../../../../../components'
import { SettingsNav } from '../../settings-nav'
import { SettingsHeading } from '../../shared'
import { CompanyName } from '../company-name'
import { CompanyRelations } from '../company-relations'
import { OrganizationDelete } from './organization-delete'
import { OrganizationLeave } from './organization-leave'

export function SettingsOrganization() {
	const { t } = useTranslation('common')

	return (
		<SettingsNav active="organization">
			<SettingsHeading>{t('organization.title')}</SettingsHeading>
			<p className="max-w-[600px] text-gray-600">
				{t('organization.description')}
			</p>

			<div className="max-w-[800px] space-y-16">
				<CompanyRelations />

				<CompanyName />

				<OrganizationLeave />

				<RequireAccess role={['admin', 'jobillan']}>
					<OrganizationDelete />
				</RequireAccess>
			</div>
		</SettingsNav>
	)
}
